// ============================================================
// Viewer 上下文 Store（DW-P0-5）：发布快照/设置/OEM/静态数据
// 供查看器渲染、水印与后续数据对接使用；不参与编辑态
// ============================================================

import { create } from 'zustand';

interface ViewerState {
  source: 'cloud' | 'local' | 'api' | null;
  snapshot: Record<string, unknown> | null;
  settings: Record<string, unknown>;
  oem: Record<string, unknown>;
  /** 动态转静态抓取结果（DW-P0-3）：key → 数据 */
  staticData: Record<string, unknown>;
  setContext: (
    patch: Partial<Pick<ViewerState, 'source' | 'snapshot' | 'settings' | 'oem' | 'staticData'>>,
  ) => void;
  reset: () => void;
}

export const useViewerStore = create<ViewerState>((set) => ({
  source: null,
  snapshot: null,
  settings: {},
  oem: {},
  staticData: {},
  setContext: (patch) => set(patch),
  reset: () => set({ source: null, snapshot: null, settings: {}, oem: {}, staticData: {} }),
}));
